export default {
  labels: {
    radius: 'Promień',
  },
};
